import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react.js";

const dashboardStyle = {
  successText: {
    color: successColor[0],
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px",
  },
  stats: {
    color: grayColor[0],
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px",
    },
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "5px",
    marginBottom: "0",
  },
  cardCategoryWhite: {
    color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontSize: "14px",
    fontWeight: "200",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "300",
      lineHeight: "1",
    },
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  typo: {
    paddingLeft: "4px",
    marginBottom: "2px",
    //position: "relative",
    //lineHeight: "1",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "4px",
    color: "#727272",
    //display: "block",
    fontWeight: "400",
    fontSize: "13px",
    marginRight: "5px",
    //lineHeight: "1",
    //left: "0",
    //marginLeft: "10px",
    //position: "absolute",
    //width: "260px",
  },
  data: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    width: "100%",
    bottom: "5px",
    color: "#0a8013",
    marginLeft: "0px",
    //display: "block",
    fontWeight: "600",
    fontSize: "13px",
    
  },
  map: {
    padding: "5px",
    width: "100%",
    height: "200px",
    /* maxHeight: "250px",
    display: "flex",
    flexDirection: "row",
    alignItems: "right", */
    //justifyContent: "center",

    
    
  },
  desc: {
    paddingLeft: "4px",
    marginBottom: "4px",
    //position: "relative",
    lineHeight: "1",
    display: "flex",
    flexDirection: "column",
    //flexWrap: "nowrap",
    
  },
};

export default dashboardStyle;
